import { Directive, ElementRef, Injector, Input } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

@Directive({
  /* tslint:disable-next-line:directive-selector */
  selector: 'cc-avatar'
})
export class Ng1AvatarDirective extends UpgradeComponent {
  @Input() avatarUrl;
  @Input() fullName;
  @Input() avatarSize;

  constructor(elementRef: ElementRef, injector: Injector) {
    super('avatar', elementRef, injector);
  }
}
